import { Currency } from '@/core/currency/interfaces';

const BSD: Currency = {
    name: 'Bahamian Dollar',
    demonym: 'Bahamian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '044',
    symbol: '$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BSD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BSD;
